/**
 * NightProgressBar - Progress bar that fills up during the night (like FNAF)
 * Shows how much time has passed in the current night
 */

import React from 'react';

interface NightProgressBarProps {
  progress: number; // 0-100 percentage
  position?: 'top' | 'bottom';
}

export const NightProgressBar: React.FC<NightProgressBarProps> = ({
  progress,
  position = 'bottom'
}) => {
  const positionStyles = position === 'top'
    ? { top: '10px' }
    : { bottom: '10px' };

  return (
    <div style={{
      position: 'absolute',
      ...positionStyles,
      left: '50%',
      transform: 'translateX(-50%)',
      width: '400px',
      pointerEvents: 'none',
      userSelect: 'none',
    }}>
      {/* Label */}
      <div style={{
        fontSize: '12px',
        fontWeight: 'bold',
        color: '#ffffff',
        textAlign: 'center',
        marginBottom: '5px',
        fontFamily: 'monospace',
        textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)',
      }}>
        NIGHT PROGRESS
      </div>

      {/* Progress bar container */}
      <div style={{
        width: '100%',
        height: '25px',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        border: '3px solid #444',
        borderRadius: '4px',
        overflow: 'hidden',
        position: 'relative',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)',
      }}>
        {/* Progress bar fill */}
        <div style={{
          width: `${progress}%`,
          height: '100%',
          background: 'linear-gradient(90deg, #1a472a 0%, #2d7a4a 50%, #1a472a 100%)',
          transition: 'width 0.5s ease',
          position: 'relative',
          overflow: 'hidden',
        }}>
          {/* Animated shine effect */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: '-100%',
            width: '200%',
            height: '100%',
            background: 'linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.3) 50%, transparent 100%)',
            animation: 'shine 3s infinite',
          }} />
        </div>

        {/* Progress percentage text */}
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          fontSize: '14px',
          fontWeight: 'bold',
          color: '#ffffff',
          fontFamily: 'monospace',
          textShadow: '2px 2px 4px rgba(0, 0, 0, 0.9)',
        }}>
          {Math.round(progress)}%
        </div>

        {/* Grid pattern overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage: 'repeating-linear-gradient(90deg, rgba(255,255,255,0.05) 0px, rgba(255,255,255,0.05) 1px, transparent 1px, transparent 20px)',
          pointerEvents: 'none',
        }} />
      </div>

      {/* Add keyframes for shine animation */}
      <style>{`
        @keyframes shine {
          0% { left: -100%; }
          100% { left: 100%; }
        }
      `}</style>
    </div>
  );
};
